import Vue from 'vue'
import Vuex from 'vuex'
import loginStore from './modules/loginStore.js'
import generalStore from './modules/generalStore.js'

Vue.use(Vuex)

export default new Vuex.Store({
   modules: {
      loginStore,
      generalStore
   }
})
